import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'BarMultid',
  props: {
    title: {
      type: String,
      default: ''
    },
    dataSource: {
      type: Array,
      default: function _default() {
        return [{
          type: '10:10',
          bar: 2,
          line: 2
        }, {
          type: '10:15',
          bar: 6,
          line: 3
        }, {
          type: '10:20',
          bar: 2,
          line: 5
        }, {
          type: '10:25',
          bar: 9,
          line: 1
        }, {
          type: '10:30',
          bar: 2,
          line: 3
        }, {
          type: '10:35',
          bar: 2,
          line: 1
        }, {
          type: '10:40',
          bar: 1,
          line: 2
        }];
      }
    },
    height: {
      type: Number,
      default: 400
    }
  },
  data: function data() {
    return {
      scale: [{
        dataKey: 'bar',
        min: 0
      }, {
        dataKey: 'line',
        min: 0
      }]
    };
  },
  computed: {
    data: function data() {
      return this.dataSource;
    }
  }
};